var Utils = require('./Utils');

function RecordForm(config,data){
    var self = this;
    self.inner = function () {};
    self.fn = function () {};

    self.inner.utils = config.utils != null ? config.utils: new Utils();
    self.inner.apiClient = self.inner.utils.getApiClient(config);

    self.id = data.id;
    self.address = ko.observable(data.address);
    self.address2 = ko.observable(data.address2);
    self.city = ko.observable(data.city);
    self.state = ko.observable(data.state);
    self.zip_code = ko.observable(data.zip_code);

    self.phone = ko.observable(data.phone);
    self.comment = ko.observable(data.comment);

    self.dont_list_address = ko.observable(data.dont_list_address == 1);
    self.dont_list_phone = ko.observable(data.dont_list_phone == 1);

    self.status = ko.observable(data.status);

    self.inner.handler_edit_mode = ko.observable(false);
    self.inner.dog_edit_mode = ko.observable(false);
    self.inner.processing = ko.observable(false);

    self.inner.touched = ko.observable(false);

    self.inner.url = {
        save_handler: config.url.save_handler,
        save_dog: config.url.save_dog,
        'delete': config.url['delete'],
        fraud: config.url.fraud
    }

    self.fn.toggleHandlerEditMode = function(){
        self.inner.handler_edit_mode(!self.inner.handler_edit_mode());
        self.inner.touched(true);
    }
    self.fn.toggleDogEditMode = function(){
        self.inner.dog_edit_mode(!self.inner.dog_edit_mode());
        self.inner.touched(true);
    }

    self.fn.validateHandler = function(){
        return true;
    }

    self.fn.validateDog = function(){
        return true;
    }

    self.fn.saveHandler = function(){
        if(!self.fn.validateHandler())
            return;

        self.inner.processing(true);
        var data = {
            id: self.id,
            address: self.address(),
            address2: self.address2(),
            city: self.city(),
            state: self.state(),
            zip_code: self.zip_code(),
            phone: self.phone(),
            comment: self.comment(),
            dont_list_address: self.dont_list_address(),
            dont_list_phone: self.dont_list_phone()
        };
        self.inner.apiClient.call(self.inner.url.save_handler,data,function(response){
            if(response.success){
               $(document).trigger('handler-updated');
            }
            else{
                self.inner.utils.alert(response.message,'error');
                self.inner.processing(false);
            }
        },function(e){
            self.inner.utils.alert('Error occurred while saving handler information','error');
            self.inner.processing(false);
        },'POST');
    }

    self.fn.saveDog = function(){
        if(!self.fn.validateDog())
            return;

        self.inner.processing(true);
        var data = {
            id: self.id,
            status: self.status()
        };
        self.inner.apiClient.call(self.inner.url.save_dog,data,function(response){
            if(response.success){
                $(document).trigger('dog-updated');
            }
            else{
                self.inner.utils.alert(response.message,'error');
                self.inner.processing(false);
            }
        },function(e){
            self.inner.utils.alert('Error occurred while saving dog information','error');
            self.inner.processing(false);
        },'POST');
    }


    self.fn.delete = function(){
        self.inner.utils.confirm("Are you sure you want to delete this record?",function(){
            self.inner.processing(true);
            var data = {
                id: self.id,
            };
            self.inner.apiClient.call(self.inner.url.delete,data,function(response){
                if(response.success){
                    $(document).trigger('record-deleted');
                }
                else{
                    self.inner.utils.alert(response.message,'error');
                    self.inner.processing(false);
                }
            },function(e){
                self.inner.utils.alert('Error occurred while deleting record','error');
                self.inner.processing(false);
            },'POST');
        });

    }

    self.fn.markAsFraudulent = function(){
        self.inner.utils.confirm("Are you sure you want to mark this record as fraudulent?",function(){
            self.inner.processing(true);
            var data = {
                id: self.id,
            };
            self.inner.apiClient.call(self.inner.url.fraud,data,function(response){
                if(response.success){
                    $(document).trigger('record-marked-as-fraudulent');
                }
                else{
                    self.inner.utils.alert(response.message,'error');
                    self.inner.processing(false);
                }
            },function(e){
                self.inner.utils.alert('Error occurred while marking record as fraudulent','error');
                self.inner.processing(false);
            },'POST');
        });

    }
}

module.exports = RecordForm;
